// Color helpers for the Circumplex configuration preview.

const clamp = (value) => Math.max(0, Math.min(255, Math.round(value)));

const hexToRgb = (hex) => {
    let normalized = hex.replace('#', '');
    if (normalized.length === 3) {
        normalized = normalized.split('').map((c) => c + c).join('');
    }
    const num = parseInt(normalized, 16);
    return {
        r: (num >> 16) & 255,
        g: (num >> 8) & 255,
        b: num & 255,
    };
};

const rgbToHex = ({ r, g, b }) =>
    '#' + [r, g, b].map((c) => clamp(c).toString(16).padStart(2, '0')).join('');

// Mix a base color towards white by `amount` (0 = base, 1 = white).
export const tintColor = (hex, amount) => {
    const { r, g, b } = hexToRgb(hex);
    return rgbToHex({
        r: r + (255 - r) * amount,
        g: g + (255 - g) * amount,
        b: b + (255 - b) * amount,
    });
};

// Generate `count` tints of a base color, from the base color to a mid-light
// tint. Capped well short of white so later sub-categories stay clearly
// coloured (not washed out to grey) in the wheel.
export const generateTints = (hex, count) => {
    if (count <= 1) return [hex];
    const tints = [];
    const maxAmount = 0.5;
    for (let i = 0; i < count; i += 1) {
        const amount = (i / (count - 1)) * maxAmount;
        tints.push(tintColor(hex, amount));
    }
    return tints;
};

// Total sub-categories across all pillars.
export const getTotalSubCategories = (pillars) =>
    pillars.reduce((sum, pillar) => sum + (pillar.subCategoriesCount || 0), 0);
